import { getVersionCrud } from '../../helpers/getVersionCrud'

export const deleteVersion = (entryId: number) => {
  return getVersionCrud().delete(
    { formId: '1233', code: 'executive-leadership-team-1233' },
    { EntryId: entryId },
    'EntryId'
  )
}
